/**
 * @jest-environment jsdom
 */
import {createSelector} from 'reselect';
import {initialState} from './reducer';

const selectState = (state) => state.LANDINGPAGE || initialState;

const selectPageName = () =>
    createSelector(
        selectState,
        state => state.pageName,
    );

const selectOffers = () =>
    createSelector(
        selectState,
        state => state.offers,
    );

const selectAdditionalContentLoading = () =>
    createSelector(
        selectState,
        state => state.additionalContentLoading,
    );

const selectError = () =>
    createSelector(
        selectState,
        state => state.error,
    );

const selectErrorMessage = () =>
    createSelector(
        selectState,
        state => state.errorMessage,
    );

const selectLoading = () =>
    createSelector(
        selectState,
        state => state.loading,
    );

const selectOffersJsonURL = () =>
    createSelector(
        selectState,
        state => state.offer_json_url,
    );

const selectDefaultOfferIds = () =>
    createSelector(
        selectState,
        state => state.default_offer_ids,
    );

const selectDefaultNotificationIsDisplayed = () =>
    createSelector(
        selectState,
        state => state.default_notification_is_displayed,
    );

const selectUserHasMobilfunk = () =>
    createSelector(
        selectState,
        state => state.has_mobilfunk,
    );
const selectUserHasInternet = () =>
    createSelector(
        selectState,
        state => state.has_internet,
    );
const selectUserHasTV = () =>
    createSelector(
        selectState,
        state => state.has_tv,
    );
const selectUserHasNone = () =>
    createSelector(
        selectState,
        state => state.has_none,
    );
const selectUserWantsMobilfunk = () =>
    createSelector(
        selectState,
        state => state.wants_mobilfunk,
    );
const selectUserWantsInternet = () =>
    createSelector(
        selectState,
        state => state.wants_internet,
    );
const selectUserWantsTV = () =>
    createSelector(
        selectState,
        state => state.wants_tv,
    );
const selectUserWantsRedplus = () =>
    createSelector(
        selectState,
        state => state.wants_redplus,
    );
const selectRecentlyClickedOption = () =>
    createSelector(
        selectState,
        state => state.recently_clicked_option,
    );

export {
    selectOffers,
    selectAdditionalContentLoading,
    selectPageName,
    selectError,
    selectErrorMessage,
    selectLoading,
    selectDefaultOfferIds,
    selectOffersJsonURL,
    selectDefaultNotificationIsDisplayed,
    selectUserHasMobilfunk,
    selectUserHasInternet,
    selectUserHasTV,
    selectUserHasNone,
    selectUserWantsMobilfunk,
    selectUserWantsInternet,
    selectUserWantsTV,
    selectUserWantsRedplus,
    selectRecentlyClickedOption,
};
